import React from 'react';
import { motion } from 'framer-motion';

const Admin = () => {
  return (
    <div className="page-container">
      <div className="page-header">
        <h1 className="page-title">管理後台 Admin Panel</h1>
        <p className="page-subtitle">
          管理投票系統和查看統計數據
        </p>
      </div>
      
      <div className="container">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="text-center"
        >
          <div className="card">
            <h2>管理後台開發中</h2>
            <p>管理後台功能正在開發中，敬請期待！</p>
            <p>Admin panel is under development. Please stay tuned!</p>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default Admin;
